import { FetchTemplatesRequest } from './../../templates/templates.actions'
import { getTemplatesState } from './../../templates/templates.selectors'
import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreatePropertyTypeTemplateRequest,
} from '../property-type-templates.actions'
import { getCreatePropertyTypeTemplateState } from '../property-type-templates.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { debounceTime, Subject, Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-create-template',
  templateUrl: './create-property-type-template.component.html',
  styleUrls: ['./create-property-type-template.component.css'],
})
export class CreatePropertyTypeTemplateComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  private state$: Subscription
  private templatesState$: Subscription
  public isLoading: boolean
  public templates: [] = []
  public isPropertyTypesOpen = false
  public onTemplatesAutocomplete$ = new Subject<string>()
  public templatesAutocomplete$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createTemplate'))
    this.state$ = this.store
      .pipe(select(getCreatePropertyTypeTemplateState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })
    this.templatesState$ = this.store
      .pipe(select(getTemplatesState))
      .subscribe((state) => {
        this.templates = state.get('data').toJS()
      })

    this.store.dispatch<any>(
      new FetchTemplatesRequest({
        filters: {
          matchAnd: [{ field: 'type', value: 'RDN_TEMPLATE' }],
        },
        pageSize: 20,
        page: 0,
      }),
    )

    this.templatesAutocomplete$ = this.onTemplatesAutocomplete$
      .pipe(debounceTime(500))
      .subscribe((keyword) => {
        if (keyword) {
          this.store.dispatch<any>(
            new FetchTemplatesRequest({
              filters: keyword
                ? {
                    or: [{ field: 'name', value: keyword }],
                    matchAnd: [{ field: 'type', value: 'RDN_TEMPLATE' }],
                  }
                : {},
              pageSize: 20,
            }),
          )
        }
      })
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.templatesState$.unsubscribe()
    this.templatesAutocomplete$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createTemplate.data',
      ),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createTemplate',
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      propertyType: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()
    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreatePropertyTypeTemplateRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createTemplate',
        ),
      )
    }
  }
}
